// extracted by mini-css-extract-plugin
module.exports = {"durationHeader":"RequestList-module_durationHeader__Z1TNzc0PUC5lJEhjqfoR","sqlTimingsHeader":"RequestList-module_sqlTimingsHeader___1113eaEB4oBvuAqlv2u"};